import React from "react";
import { UserMenu } from "@/components/UserMenu";

interface HeaderProps {
  onTitleClick?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onTitleClick }) => {
  return (
    <header className="app-header">
      <div className="header-left">
        <h1 className="app-title" onClick={onTitleClick} style={{ cursor: "pointer" }}>DeepSearch</h1>
        <span className="app-subtitle">AI 深度研究助手</span>
      </div>
      <div className="header-right">
        <UserMenu />
      </div>
    </header>
  );
};
